export function readHtmlTagAttributes(tag: string): { className?: string; style?: string } {
  const classMatch = tag.match(/\bclass\s*=\s*["']([^"']*)["']/i)
  const styleMatch = tag.match(/\bstyle\s*=\s*["']([^"']*)["']/i)
  return {
    className: classMatch?.[1]?.trim() || undefined,
    style: styleMatch?.[1]?.trim() || undefined,
  }
}

export function wrapHtmlInnerWithRootAttributes(inner: string, rootTag: string): string {
  const { className, style } = readHtmlTagAttributes(rootTag)
  if (!className && !style) return inner

  const attrs: string[] = []
  if (className) attrs.push(`class="${className}"`)
  if (style) attrs.push(`style="${style}"`)
  return `<div ${attrs.join(' ')}>${inner}</div>`
}
